import React, { useState } from 'react';
import { Search, Sparkles, SlidersHorizontal } from 'lucide-react';
import './TextesDeLoi.css';

const CATEGORIES = [
  'Toutes les catégories',
  'Codes',
  'Lois',
  'Ordonnances',
  'Décrets',
  'Arrêtés',
  'Traités',
  'Règlements',
];

const TextesDeLoi: React.FC = () => {
  const [query, setQuery] = useState('');
  const [advancedOpen, setAdvancedOpen] = useState(false);
  const [category, setCategory] = useState('');
  const [articleNum, setArticleNum] = useState('');
  const [dateFrom, setDateFrom] = useState('');

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    // Search logic placeholder
    alert('Recherche: ' + query);
  };

  const handleApplyFilters = () => {
    alert(`Filtres: Catégorie=${category}, Article=${articleNum}, Date=${dateFrom}`);
  };

  const handleReset = () => {
    setCategory('');
    setArticleNum('');
    setDateFrom('');
  };

  return (
    <div className="textes-page">
      {/* Hero section */}
      <section className="textes-hero">
        <div className="textes-hero-bg"></div>
        <div className="textes-hero-content">
          <div className="ai-badge">
            <Sparkles size={16} />
            Propulsé par l'Intelligence Artificielle
          </div>
          <h1 className="textes-title">
            Toute la législation <span className="textes-title-orange">ivoirienne</span>
          </h1>
          <p className="textes-subtitle">Accessible, Actualisée et Intelligente</p>

          <div className="textes-search-wrapper">
            <form className="textes-search" onSubmit={handleSearch}>
              <input
                type="text"
                placeholder="Rechercher par mot-clé, numéro d'article ou thématique..."
                value={query}
                onChange={(e) => setQuery(e.target.value)}
              />
              <button type="submit" className="textes-search-btn">
                <Search size={18} />
                Rechercher
              </button>
            </form>
          </div>

          <button
            className={`textes-advanced-btn ${advancedOpen ? 'active' : ''}`}
            onClick={() => setAdvancedOpen(!advancedOpen)}
            type="button"
          >
            <SlidersHorizontal size={16} />
            Recherche avancée
          </button>

          {advancedOpen && (
            <div className="textes-advanced-panel">
              <div className="textes-filters-grid">
                <div className="textes-filter-group">
                  <label>Catégorie</label>
                  <select value={category} onChange={(e) => setCategory(e.target.value)}>
                    {CATEGORIES.map(c => (
                      <option key={c} value={c === 'Toutes les catégories' ? '' : c}>
                        {c}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="textes-filter-group">
                  <label>Numéro d'article</label>
                  <input
                    type="text"
                    placeholder="Ex: Art. 5"
                    value={articleNum}
                    onChange={(e) => setArticleNum(e.target.value)}
                  />
                </div>
                <div className="textes-filter-group textes-filter-full">
                  <label>Date d'adoption (à partir de)</label>
                  <input
                    type="date"
                    value={dateFrom}
                    onChange={(e) => setDateFrom(e.target.value)}
                  />
                </div>
              </div>
              <div className="textes-filter-actions">
                <button className="btn-apply-filters" onClick={handleApplyFilters} type="button">
                  Appliquer les filtres
                </button>
                <button className="btn-reset-filters" onClick={handleReset} type="button">
                  Réinitialiser
                </button>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Description section */}
      <section className="textes-description">
        <p>
          <strong>DATAGREFFE</strong> <span className="legis-highlight">Legis</span> révolutionne
          l'accès aux textes de loi, aux codes, aux traités, aux arrêtés, aux règlements et à
          l'ensemble de la législation ivoirienne grâce à la puissance de l'IA.
        </p>
      </section>
    </div>
  );
};

export default TextesDeLoi;
